import React from 'react'
import { useLocation } from 'react-router-dom'

import OfferDetailsForm from '@/components-latest/ui/OfferPage/OfferDetailsForm'
import {
  useOfferFormNavigateBack,
  useOfferFormSuccessNavigate
} from '@/hooks/useOfferFormNavigateBack/useOfferFormNavigateBack'

type OfferDetailsLocationState = {
  isEditing?: boolean
  offerId?: string
  initialDiscount?: number
  initialExpiration?: string
  name?: string
}

const resolveLocationState = (
  locationState: unknown
): OfferDetailsLocationState | undefined => {
  if (!locationState || typeof locationState !== 'object') return undefined

  if (
    'state' in locationState &&
    locationState.state &&
    typeof locationState.state === 'object'
  ) {
    return locationState.state as OfferDetailsLocationState
  }

  return locationState as OfferDetailsLocationState
}

const OfferDetailsFormWrapper: React.FC = () => {
  const location = useLocation()
  const state = resolveLocationState(location.state)

  const navigateOnSuccess = useOfferFormSuccessNavigate('item_discount')

  const handleSuccess = () => {
    navigateOnSuccess(state?.offerId ? 'edit' : 'create')
  }

  const handleGoBack = useOfferFormNavigateBack('item_discount')

  return (
    <OfferDetailsForm
      onSuccess={handleSuccess}
      onGoBack={handleGoBack}
      offerId={state?.offerId}
      initialDiscount={state?.initialDiscount}
      initialExpiration={state?.initialExpiration}
      name={state?.name}
    />
  )
}
export default OfferDetailsFormWrapper
